import { FeeLevelType } from '../../types/index';
import { updateFeeLevel } from "actions/Utilities/FeeLevel";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useUpdateFeeLevel = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (feeLevelNewData: FeeLevelType) => updateFeeLevel(feeLevelNewData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetFeeLevels"]);
        toast.fire("Success", "Fee Level Updated Successfully", "success");
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update Fee Level", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateFeeLevel;
